import { __assign } from '../node_modules/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import SvgIcon from '@mui/material/SvgIcon';

var ArrowLeftIcon = forwardRef(function (props, ref) {
    return (React.createElement(SvgIcon, __assign({}, props, { ref: ref }),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "30.607", height: "20.593", viewBox: "0 0 30.607 20.593" },
            React.createElement("g", { "data-name": "Group 13128" },
                React.createElement("g", { "data-name": "Group 222" },
                    React.createElement("path", { "data-name": "Path 232", d: "m5.482 141.031 8.592-8.551a1.644 1.644 0 0 1 2.32 2.331l-5.769 5.741h23.238a1.644 1.644 0 0 1 0 3.289H10.627l5.769 5.741a1.644 1.644 0 0 1-2.32 2.331l-8.592-8.551a1.646 1.646 0 0 1-.002-2.331z", transform: "translate(-4.95 -131.848)", fill: "currentColor", strokeWidth: 1.7 }))))));
});

export { ArrowLeftIcon };
//# sourceMappingURL=ArrowLeftIcon.js.map
